import { DEFAULT_TIMEZONE, FULL_DAY_VIEW_INTERVAL } from 'Data/constants.js'
import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let isMediaMobile = useDataValue({
    context: 'media',
    path: 'mobile',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    let time_zone_id = props.location.time_zone_id || DEFAULT_TIMEZONE
    let slot_interval = props.slotInterval || data.slot_interval

    return {
      ...data,
      events: props.events || data.events,
      resources: props.resources || data.resources,
      appointment_type_candidates:
        props.appointment_type_candidates || data.appointment_type_candidates,
      date: props.date || new Date(),
      location: {
        ...props.location,
        time_zone_id,
      },
      slot_interval,
      is_full_day_view: slot_interval === FULL_DAY_VIEW_INTERVAL,
      slot_min_time: props.slotMinTime || data.slot_min_time,
      slot_max_time: props.slotMaxTime || data.slot_max_time,
      hipaa: props.hipaa || data.hipaa,
      open_dialog_near_click: isMediaMobile || props.resources?.length < 3,
      focused_event_id: props.focusedEventId || data.focused_event_id,
      scheduling_config: props.schedulingConfig || data.scheduling_config,
      resource_width: props.resourceWidth || data.resource_width,
      has_appointment_template_filters: Boolean(
        props.hasAppointmentTemplateFilters ||
          data.has_appointment_template_filters
      ),
      appointment_queue: props.appointment_queue || data.appointment_queue,
      dragged_appointment:
        props.dragged_appointment || data.dragged_appointment,
    }
  }, [
    data,
    props.events,
    props.resources,
    props.date,
    props.location,
    props.slotInterval,
    props.slotMinTime,
    props.slotMaxTime,
    props.hipaa,
    props.focusedEventId,
    props.schedulingConfig,
    props.resourceWidth,
    props.hasAppointmentTemplateFilters,
    props.appointment_type_candidates,
    props.appointment_queue,
    props.dragged_appointment,
    isMediaMobile,
  ])
}
